
import Vue from "vue";
import { mapState } from "vuex";
import { ValidationProvider } from "vee-validate";
import { userApi } from "@/api/users";
import store from "@/store";
import { mailboxApi } from "@/api/mailbox";
import { templateApi } from "@/api/template";
import { sectorApi, warehouseApi } from "@/api/misc";
import { blackBoardApi } from "@/api/blackboards";
import { authApi } from "@/api/auth";

function sleep(ms: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

export default Vue.extend({
  name: "MyLogin",
  data() {
    return {
      password: "",
      username: "",
      loading: false,
      blocked: false,
      error: false,
      showPassword: false,
      loginFailed: 0,
      blockedSeconds: 0
    };
  },

  computed: mapState("auth", ["currentUser"]),

  methods: {
    async login() {
      if (this.loginFailed > 10) {
        return;
      }
      if (this.loginFailed > 3) {
        this.blockedSeconds = 10 * this.loginFailed;
        this.loading = true;
        this.blocked = true;
        await sleep(10000 * this.loginFailed);
        this.blocked = false;
        this.loading = false;
      }
      this.error = false;
      const success = await this.$store.dispatch("auth/login", {
        username: this.username,
        password: this.password
      });
      if (success) {
        this.loading = true;
        authApi.listRoles().then(values => {
          store.commit("role/setRoles", values);
          userApi.list().then(values => {
            store.commit("user/setAllUsers", values);
            mailboxApi.list().then(values => {
              store.commit("mailbox/setAllMailboxes", values);

              templateApi.listTemplates().then(values => {
                store.commit("template/setTemplates", values);

                sectorApi.listSectors().then(values => {
                  store.commit("sector/setSectors", values);

                  warehouseApi.listWarehouses().then(values => {
                    store.commit("warehouse/setWarehouses", values);

                    blackBoardApi.list().then(async values => {
                      store.commit("taskboard/setTaskBoards", values);
                      if (
                        this.$route.query.view &&
                        this.$route.query.view.length > 2 &&
                        this.$route.query.view.length < 50
                      ) {
                        await this.$router.push("" + this.$route.query.view);
                      } else {
                        if (
                          this.$store.state.auth.currentUser.roles.filter(
                            (r: string) => r === "TERMIN_USER"
                          ).length > 0
                        ) {
                          await this.$router.push("/appointmentcalendar");
                        } else if (
                          this.$store.state.auth.currentUser.roles.filter(
                            (r: string) => r === "ADMIN"
                          ).length > 0
                        ) {
                          await this.$router.push("/dashboards");
                        } else {
                          await this.$router.push("/emails");
                        }
                      }
                    });
                  });
                });
              });
            });
          });
        });
      } else {
        this.loginFailed++;
        this.error = true;
        this.loading = false;
      }
    }
  },

  components: {
    ValidationProvider
  }
});
